export default {
	systemUser: 'Super Admin',
	accountManager: 'Account Manager',
	supervisor: 'Supervisor',
	branchManager: 'Branch Manager',
	salesPerson: 'Sales Person',
	tenantOwner: 'Tenant Owner',
	admin: 'Admin',
	superAdmin: 'Super Admin',
	systemOwner: 'System Owner',
	contributor: 'Contributor',
	warehouseClerk: 'Warehouse Clerk',
	accountant: 'Accountant',
};

export const PORTAL_TYPES: any = {
	SYSTEM_PORTAL: 'SYSTEM_PORTAL',
	TENANT_PORTAL: 'TENANT_PORTAL',
	BRANCH_PORTAL: 'BRANCH_PORTAL'
};

export const PORTAL_TYPES_DEFAULT_ROUTE: any = {
	SYSTEM_PORTAL: '/dashboard',
	TENANT_PORTAL: '/dashboard',
	BRANCH_PORTAL: '/dashboard',
	CONTRIBUTOR: '/catalog/products',
	WAREHOUSE_CLERK: '/orders',
	ACCOUNTANT: '/payments',
};

export const validImageName = new RegExp(
	'^[a-zA-Z0-9-]*_P[1-9][0-9]*.[A-Za-z]+$'
);

export const validItemNo = new RegExp('^[a-zA-Z0-9-_]*$');

export const orderAppType = [
	{
		id: 1,
		value: "sales_app"
	},
	{
		id: 2,
		value: "customer_app"
	},
	{
		id: 3,
		value: "supervisor_app"
	},
	{
		id: 4,
		value: "tenant_owner"
	},
	{
		id: 5,
		value: "admin"
	}
];
